<script>
  import Button from "../../Shared/Button.svelte"
  import BadgeState from "../../Stores/badgeState"
  import DropDown from "../../../File/Edit/Components/dropDown.svelte"
  import FontsizeDropdown from "./../../../File/Edit/Components/fontsizeDropdown.svelte"
  import defaultFonts from "../../../File/stores/fileTemplateDefaultFonts"

  export let operation

  // let fontFamily = ["Arial", "Arial Black", "Algerian", "Courier New", "Comic Sans MS", "Impact", "Times New Roman", "Tahoma", "Verdana"]
  let fontSize = [20, 40, 60, 80, 100, 120, 140, 160, 180, 200]

  $: operation.x = Math.floor(operation.x)
  $: changeInputY(operation.y)
  const changeInputY = (y) => {
    operation.inputY = Math.floor($BadgeState.baseInfo.height - y)
  }

  const moveCursor = (id) => {
    $BadgeState.operations = $BadgeState.operations.map((operation) => {
      operation.move = false
      if (operation.id == id) {
        $BadgeState.cursorPosition.x = operation.x
        $BadgeState.cursorPosition.y = operation.y
        operation.move = true
      }
      return operation
    })
  }

  $: if (operation.move) {
    operation.x = $BadgeState.cursorPosition.x
    operation.y = $BadgeState.cursorPosition.y
  }

  const chooseColor = (e) => {
    operation.textColor = e.target.value //colorvalue = white
    $BadgeState.activeTextColor = e.target.value
  }

  const preventKeys = (e) => {
    const KEYS_TO_PREVENT = ["-", "+", "e", "E"]
    if (KEYS_TO_PREVENT.includes(e.key)) e.preventDefault()
  }
</script>

<svelte:window on:keydown />

<div class="flex w-full flex-col gap-3 rounded-md border {operation.active ? 'border-extraBlue-500' : 'border-transparent'} {!operation.value.trim() ? 'border-yellow-500' : ''} bg-[#292A2F] p-6">
  <div class="flex w-full items-center justify-between bg-transparent">
    <div class="flex w-full items-center justify-between gap-3">
      <Button
        on:click={() => {
          if (operation.radius != 0) operation.radius = 0
          else operation.radius = 100
        }}
        text={operation.radius != 0 ? "Wrap Straight" : "Wrap Circle"}
        addClass="w-full {operation.radius != 0 ? 'bg-extraBlue-500' : 'bg-green-500'}"
        iconClass={operation.radius != 0 ? "fa-minus" : "fa-circle-dashed"}
      />
    </div>
  </div>
  {#if operation.radius != 0}
    <div class="flex items-center gap-3">
      <!-- input x -->
      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">R</div>
        <button
          on:click|preventDefault={() => {
            operation.radius = operation.radius + 5
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click|preventDefault={() => {
            if (operation.radius > 0) operation.radius = operation.radius - 5
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <!-- on:wheel|preventDefault|stopPropagation={(e) => {
            if (e.deltaY < 0) {
              operation.x = operation.x + 10
            } else {
              operation.x = operation.x - 10
            }
          }} -->

        <input
          min="0"
          type="number"
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.radius}
          class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
      </div>
      <!-- input y -->

      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">S</div>
        <button
          on:click={() => {
            operation.letterSpacing = operation.letterSpacing + 5
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={() => {
            if (operation.letterSpacing > 0) operation.letterSpacing = operation.letterSpacing - 5
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <input
          min="0"
          on:keypress={preventKeys}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          bind:value={operation.letterSpacing}
          on:change={(e) => {
            const value = parseFloat(e.target.value)

            // Check if input is empty or invalid
            if (isNaN(value) || value === null || value === "") {
              operation.letterSpacing = 5 // Default to 5
              e.target.value = 5 // Update input value to show the default
            } else {
              operation.letterSpacing = value // Accept valid input
            }
          }}
          type="number"
          class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
      </div>
    </div>
  {/if}
  <!-- <div class="group relative w-full rounded-md">
    <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00">NAME</div>
    <input type="text" value="Text layer" required class="invalid:animate-shake w-full select-none truncate rounded-md border border-stone-700 bg-transparent py-2 pl-16 pr-10 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500" />
    <div class="absolute right-3 top-2.5 select-none text-sm font-bold text-white">
      <div class="cursor-pointer" data-tooltip="Use attribute" tooltip-position="left">
        <i class="fa-solid fa-brackets-curly" />
      </div>
    </div>
  </div> -->

  <div class="group relative w-full rounded-md">
    <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">TITLE</div>
    <input
      type="text"
      on:keydown={(e) => {
        if (e.key == "Delete") {
          e.stopPropagation()
        }
      }}
      bind:value={operation.value}
      placeholder="Enter the value"
      readonly={operation.value == "Click to verify"}
      class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500"
    />
  </div>
  <!-- <div class="flex items-center gap-3">
    <div class="w-3/4">
      <FontFamilyDropDown dropdownItems={fontFamily} bind:activeItem={operation.fontFamily} />
    </div>
    <div class="w-1/4">
      <FontsizeDropdown dropdownItems={fontSize} bind:activeItem={operation.fontSize} />
    </div>
  </div> -->
  <div class="flex justify-start gap-3">
    <DropDown dropdownItems={$defaultFonts.selectedFonts} bind:activeItem={operation.fontFamily} />
    <div class="w-32">
      <FontsizeDropdown dropdownItems={fontSize} bind:activeItem={operation.fontSize} />
    </div>
  </div>
  <div class="flex items-center gap-3">
    <!-- input x -->
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">X</div>
      <button
        on:click|preventDefault={() => {
          if (operation.x + 10 <= $BadgeState.baseInfo.width) {
            operation.x = operation.x + 10
          } else {
            operation.x = $BadgeState.baseInfo.width // Stop at the width boundary
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click|preventDefault={() => {
          if (operation.x - 10 >= 0) {
            operation.x = operation.x - 10
          } else {
            operation.x = 0 // Stop at the left boundary
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>
      <!-- on:wheel|preventDefault|stopPropagation={(e) => {
          if (e.deltaY < 0) {
            operation.x = operation.x + 10
          } else {
            operation.x = operation.x - 10
          }
        }} -->

      <input
        min="0"
        type="number"
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        bind:value={operation.x}
        class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
        placeholder="10"
      />
    </div>
    <!-- input y -->

    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">Y</div>
      <button
        on:click={() => {
          if (operation.y - 10 >= 0) {
            operation.y = operation.y - 10
          } else {
            operation.y = 0 // Stop at the top boundary
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click={() => {
          if (operation.y + 10 <= $BadgeState.baseInfo.height) {
            operation.y = operation.y + 10
          } else {
            operation.y = $BadgeState.baseInfo.height // Stop at the bottom boundary
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>
      <!-- on:wheel|preventDefault|stopPropagation={(e) => {
          if (e.deltaY < 0) {
            operation.y = operation.y - 10
            operation.inputY = operation.inputY + 10
          } else {
            operation.y = operation.y + 10
            operation.inputY = operation.inputY - 10
          }
        }} -->
      <input
        min="0"
        on:input={(e) => {
          operation.y = $BadgeState.baseInfo.height - e.target.value
          // operation.inputY = e.target.value
          // document.getElementById("yinput").value = e.target.value
        }}
        bind:value={operation.inputY}
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        type="number"
        class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
        placeholder="10"
      />
    </div>

    <button data-tooltip="Move" on:click={() => moveCursor(operation.id)} tooltip-position="top" class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-extraBlue-500 active:bg-extraBlue-500">
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-arrow-pointer" />
      </span>
    </button>
  </div>
  <div class="flex flex-col gap-1.5">
    <h1 class="text-left text-sm font-medium text-gray-500">Rotation angle (degree)</h1>
    {#if operation.radius != 0}
      <div class="flex w-full items-center gap-3">
        <input
          min="0"
          max="360"
          step="1"
          on:input={(e) => {
            if (!e.target.value) operation.rotation = 0
            else if (e.target.value > 360) operation.rotation = 360
            else if (e.target.value < 0) operation.rotation = 0
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.rotation}
          type="number"
          class="w-fit select-none rounded-md border border-stone-700 bg-transparent py-2 px-3 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
        <!-- <h1 class="w-20 select-none text-xl font-bold tracking-wide text-extraBlue-500">{operation.offset ? Math.round(operation.offset) : operation.offset}°</h1> -->
        <input min="0" max="360" step="1" bind:value={operation.rotation} type="range" class="w-full cursor-pointer outline-none" />
      </div>
    {:else}
      <div class="flex w-full items-center gap-3">
        <input
          min="0"
          max="360"
          step="1"
          on:input={(e) => {
            if (!e.target.value) operation.rotation = 0
            else if (e.target.value > 360) operation.rotation = 360
            else if (e.target.value < 0) operation.rotation = 0
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.rotation}
          type="number"
          class="w-fit select-none rounded-md border border-stone-700 bg-transparent py-2 px-3 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
        <!-- <h1 class="w-20 select-none text-xl font-bold tracking-wide text-extraBlue-500">{operation.rotation ? Math.round(operation.rotation) : 0}°</h1> -->
        <input min="0" max="360" step="1" bind:value={operation.rotation} type="range" class="w-full cursor-pointer outline-none" />
      </div>
    {/if}
  </div>

  <div class="flex items-center justify-between">
    <button
      on:click={() => {
        operation.textAlign = "left"
        $BadgeState.activeTextAlign = "left"
      }}
      data-tooltip="Align left"
      tooltip-position="top"
      class="flex items-center rounded-md border {operation.textAlign == 'left' ? 'bg-zinc-900 ring-1 ring-extraBlue-500' : ''} border-stone-700 bg-transparent p-2 text-lg text-gray-g00 focus:outline-none"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-align-left" />
      </span>
    </button>
    <button
      on:click={() => {
        operation.textAlign = "center"
        $BadgeState.activeTextAlign = "center"
      }}
      data-tooltip="Align center"
      tooltip-position="top"
      class="flex items-center rounded-md {operation.textAlign == 'center' ? 'bg-zinc-900 ring-1 ring-extraBlue-500' : ''} border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 focus:outline-none"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-align-center" />
      </span>
    </button>
    <button
      on:click={() => {
        operation.textAlign = "right"
        $BadgeState.activeTextAlign = "right"
      }}
      data-tooltip="Align right"
      tooltip-position="top"
      class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 {operation.textAlign == 'right' ? 'bg-zinc-900 ring-1 ring-extraBlue-500' : ''} text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-align-right" />
      </span>
    </button>

    <button
      on:click={() => {
        if (!operation.fontWeight.includes("Bold")) {
          operation.fontWeight = [...operation.fontWeight, "Bold"]
        } else {
          operation.fontWeight = operation.fontWeight.filter((font) => font !== "Bold")
        }
        $BadgeState.activeFontStyles = [...operation.fontWeight]
      }}
      data-tooltip="Bold"
      tooltip-position="top"
      class="flex items-center rounded-md border {operation.fontWeight.includes('Bold') ? 'bg-zinc-900 outline-none ring-1 ring-extraBlue-500' : ''} border-stone-700 bg-transparent p-2 text-lg text-gray-g00"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-bold" />
      </span>
    </button>
    <button
      on:click={() => {
        if (!operation.fontWeight.includes("Italic")) {
          operation.fontWeight = [...operation.fontWeight, "Italic"]
        } else {
          operation.fontWeight = operation.fontWeight.filter((font) => font !== "Italic")
        }
        $BadgeState.activeFontStyles = [...operation.fontWeight]
      }}
      data-tooltip="Italic"
      tooltip-position="top"
      class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 {operation.fontWeight.includes('Italic') ? 'bg-zinc-900 outline-none ring-1 ring-extraBlue-500' : ''}"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-italic" />
      </span>
    </button>
    <button
      on:click={() => {
        if (!operation.fontWeight.includes("Underline")) {
          operation.fontWeight = [...operation.fontWeight, "Underline"]
        } else {
          operation.fontWeight = operation.fontWeight.filter((font) => font !== "Underline")
        }
        $BadgeState.activeFontStyles = [...operation.fontWeight]
      }}
      data-tooltip="Underline"
      tooltip-position="top"
      class="flex items-center {operation.fontWeight.includes('Underline') ? 'bg-zinc-900 outline-none ring-1 ring-extraBlue-500' : ''} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-underline" />
      </span>
    </button>
    <button data-tooltip="Color" tooltip-position="top" class="flex items-center">
      <input on:input={chooseColor} type="color" class="absolute inset-0 h-7 w-7 cursor-pointer opacity-0" />
      <img class="h-7 w-7 flex-shrink-0 cursor-pointer rounded-full" src="assets/img/color-wheel.png" alt="colorWheel" />
    </button>
  </div>
</div>
